import React from "react";
import styled from "styled-components";
import { I18n } from "@aws-amplify/core";

import media from "../../utils/media";
import GlobalBibleLogoIcon from "icons/GlobalBibleLogoIcon";
import { Theme } from "../../typedefs-ui/Theme";

interface FooterContainerProps {
  hasParallels: boolean;
  theme: Theme;
}

export const FooterContainer = styled.div<FooterContainerProps>`
  padding: 1em 0;
  padding-bottom: 3em;
  display: none;
  ${media.desktop`
    display:block;
    position: relative;
    width: ${(props: FooterContainerProps) =>
      props.hasParallels ? "86%" : "80%"};
    max-width: ${(props: FooterContainerProps) =>
      props.hasParallels ? "86%" : "800px"};
    margin: 0 auto;
    `};
  a {
    text-decoration: none;
    font-size: 0.75em;
    color: ${props => (props.theme.darkMode ? "#dddddd" : "#000000")};
    transition: color 0.5s ease;
    &:hover {
      color: ${props => props.theme.computedPrimary};
    }
  }
`;

const Logo = styled.div`
  display: inline-block;
  width: 24px;
  vertical-align: middle;
  margin-right: 0.5em;
  svg {
    fill: ${props => (props.theme.darkMode ? "#dddddd" : "#000000")};
  }
`;

const LeftLink = styled.a`
  position: absolute;
  left: 1em;
`;

const RightLinks = styled.span`
  position: absolute;
  right: 1em;
`;

interface FooterProps {
  hasParallels: boolean;
}

const Footer: React.FC<FooterProps> = ({ hasParallels }) => (
  <FooterContainer hasParallels={hasParallels}>
    <LeftLink href="https://global.bible">
      <Logo>
        <GlobalBibleLogoIcon size={24} />
      </Logo>
      The Global Bible Project
    </LeftLink>
    <RightLinks>
      <a href="/privacy" target="_blank">
        {I18n.get("Privacy")}
      </a>{" "}
      |{" "}
      <a href="/terms" target="_blank">
        {I18n.get("Terms and Conditions")}
      </a>
    </RightLinks>
  </FooterContainer>
);

export default Footer;
